import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
export interface PromoCode {
  id?: number;
  type: '0' | '1';
  expiration_date?: string | null;
  percentage?: number | null;
  code: string;
  active?: boolean;
}
export interface ValidateResponse {
  valid: boolean;
  message: string;
  data: PromoCode | null;
}

@Injectable({
  providedIn: 'root',
})
export class PromocodeService {
  private apiUrl = `${environment.Server_URL}/promo-codes`;

  constructor(private http: HttpClient) {}
  validate(code: string): Observable<ValidateResponse> {
    const safe = encodeURIComponent(code.trim());
    return this.http.get<ValidateResponse>(`${this.apiUrl}/validate/${safe}`);

  }
}
